/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CurrentUserTenantsResponseDto = {
  id: number;
  name: string;
  status: CurrentUserTenantsResponseDto.status;
};
export namespace CurrentUserTenantsResponseDto {
  export enum status {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
  }
}

